// extracted by mini-css-extract-plugin
export default {"container_card":"single_card_container_card__AHD3J","img_card":"single_card_img_card__1depb","title_card":"single_card_title_card__rZODR"};